class WishlistCounter extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.observeWishlistCount()
  }

  observeWishlistCount () {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'childList' ||
          mutation.type === 'characterData'
        ) {
          if (Number(mutation.target.textContent) > 0) {
            this.wishlistCount.ariaHidden = false
          } else {
            this.wishlistCount.ariaHidden = true
          }
        }
      })
    })

    observer.observe(this.wishlistCount, {
      characterData: true,
      childList: true,
      subtree: true,
    })
  }

  get wishlistCount () {
    return this.els.count.element
  }
}

if (!customElements.get('wishlist-counter')) {
  customElements.define('wishlist-counter', WishlistCounter)
}
